var exports = {
  "k": "xfd349460--72af43--container",
};

module.exports = exports;
